import React, { Component } from "react";
import { Link } from "react-router-dom";
import './Right.css';
import Service from '../service/Service';

const service = new Service();

class Right extends Component {
    constructor(props) {
        super(props);
        this.formStyle = {
            marginBottom: "1px",
            height: "59px"
        }
        this.arialErrorStyle = {
            display: "block",
            fontFamily: 'Roboto',
            fontSize: '12px',
            height: '19px',
            color: '#fff'
        }
        this.formgroupStyle = {
            height: '100px'
        }
        this.captchaStyle = {
            width: '304px',
            height: '78px'
        }
        this.captchaResponseStyle = {
            width: "250px",
            height: '40px',
            border: '1px solid rgb(193, 193, 193)',
            margin: '10px 25px',
            padding: '0px',
            resize: 'none',
            display: 'none',
        }
        this.state = {
            askQueTitle: '',
            askQueSubtitle: '',
            hideLoginCard: false
        };
    }

    componentDidMount() {
        if (this.props && this.props.url) {
            if (this.props.url.includes('/discussions')) {
                this.setState({ askQueTitle: 'Want to Comment, Follow or Share this Discussion?' });
            }
            if (this.props.url.includes('/baby-names')) {
                this.setState({ askQueTitle: 'Find and Share Baby Names with Friends and Families.' });
            }
            if (this.props.url.includes('/qna')) {
                this.setState({ askQueTitle: 'Want to share your parenting queries and get answers' });
                this.setState({ askQueSubtitle: 'Get Solutions and advice from other parents and experts' });
            }
            if (this.props.url.includes('/tools') || this.props.url.includes('/videos')) {
                this.setState({ hideLoginCard: true });
            }
        }
    }

    ValidatePreMobileNo = (txtMobileNoPrefix) => {
        // var e = document.getElementById(txtMobileNoPrefix).value.trim();
        // if (e == "") {
        //     document.getElementById(txtMobileNoPrefix).value = "+91"
        // }
    }

    submitdata = (id) => {
        // var flag = ValidateMobileNo('txtRMbl', 'MblErrMsg');
        // captcha_response1 = grecaptcha.getResponse(captcha_render1);
        // if (flag && captcha_response1 != '') {
        //     $('#capErrorpg').html('');
        //     var smsurl;
        //     var mobileno = $("#txtRMbl").val();
        //     var err = document.getElementById("MblErrMsg");
        //     var apptype = "A";
        //     var event_lable = "android-sms-buttonclick";
        //     if (id == "rdoiphone") {
        //         apptype = "I";
        //         event_lable = "ios-sms-buttonclick"
        //     }
        //     smsurl = shoppingcartmainurl + "/svcs/CommonService.svc/SendAppSms?type=" + apptype + "&mobile=" + mobileno;
        //     settracknew("Fetus Movement Tracker Clicks", "right hand widget|appdownload banner", event_lable);
        //     $.ajax({
        //         async: !0,
        //         type: "POST",
        //         url: smsurl,
        //         contentType: "application/json; charset=utf-8",
        //         dataType: "json",
        //         processData: !0,
        //         success: function (response) {
        //             err.innerHTML = "Sent Sucessfully";
        //             err.style.display = "block";
        //             err.style.color = "green";
        //             $('#capErrorpg').html('');
        //             grecaptcha.reset(captcha_render1);
        //             return
        //         },
        //         error: function (l, response) { }
        //     })
        // } else {
        //     if (captcha_response1 == '') {
        //         $('#capErrorpg').html('Captcha is not selected')
        //     }
        // }
    }

    render() {
        return (
            <aside className="registrationRight left">
                <div className="rightside">
                    {((global.ftk == '' && !this.state.hideLoginCard) || (this.props && this.props.url && this.props.url.includes('/qna') && !this.props.url.includes('/qna/intentmapping'))) &&
                        <div className="askAQues loginwindow">
                            {this.state.askQueTitle && this.state.askQueTitle != '' &&
                                <div className="q4 askque-title">{this.state.askQueTitle}</div>
                            }
                            {this.state.askQueSubtitle && this.state.askQueSubtitle != '' &&
                                <div className="q8 askque-text">{this.state.askQueSubtitle}</div>
                            }
                            {this.props && this.props.url && this.props.url.includes('/qna') ?
                                <span className="ask-a-que-btn" id="devaskQuestion">
                                    <span className="b_1 ask-a-que-btn">
                                        <span className="ask-a-que-btn">Ask a Question</span>
                                    </span>
                                </span>
                                :
                                <span>
                                    <span className="b_1 mrgright">
                                        <a href={service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL)} target="_self">Login</a>
                                    </span>
                                    <span className="b_1">
                                        <a href={service.getRedirectUrl(global.registerUrl + '?URL=' + global.currentURL)} target="_self">Register</a>
                                    </span>
                                </span>
                            }
                        </div>
                    }
                    <div className="downloadApp left">
                        <p className="askedanswer r1542 allHave">Join the largest community of parents and see parenting in a new way</p>
                        <p className="bPink18">Download our App</p>
                        <div className="regParent left">
                            <div className="login" style={{ display: 'inline-block', overflow: 'hidden' }}>
                                <div className="form left" style={this.formStyle}>
                                    <input readOnly id="txtMobileNoPrefix" className="txtmobileprefix plus_sign" type="text" onBlur={this.ValidatePreMobileNo('txtMobileNoPrefix')} placeholder="+91" data-role="none" value="+91" maxLength="3" />
                                    <input id="txtRMbl" data-role="none" maxLength="15" placeholder="Enter phone number" className="Mobile" type="text" />
                                    <span id="MblErrMsg" className="spanErrorMsg R11red left"></span>
                                    <span className="spanErrorMsg left" id="AriaErrorMsg" style={this.arialErrorStyle}></span>
                                </div>
                            </div>
                            {/* <div className="form-group" style={this.formgroupStyle}>
                                <div className="g-recaptcha" id="captcha1">
                                    <div style={this.captchaStyle}>
                                        <div>
                                            <iframe src="https://www.google.com/recaptcha/api2/anchor?ar=1&k=6Ld73CcUAAAAAIZZPuzZImxnVXQauhwj-Swybc4b&co=aHR0cHM6Ly9wYXJlbnRpbmcuZmlyc3RjcnkuY29tOjQ0Mw..&hl=en&v=v1568616409584&size=normal&cb=uryi6e846ab3" width="304" height="78" role="presentation" name="a-bv3o7ot0ocea" frameBorder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox" title="catpcha_title"></iframe>
                                        </div>
                                        <textarea id="g-recaptcha-response" name="g-recaptcha-response" className="g-recaptcha-response" style={this.captchaResponseStyle}></textarea>
                                    </div>
                                </div>
                                <span id="capErrorpg"></span>
                            </div> */}
                            <div className="iosAndroid" style={{ display: 'inline-block', overflow: 'hidden' }}>
                                <div data-id="ios" className="getIos left askB_1 button-lft" id="rdoiphone" onClick={this.submitdata(this.id)}>
                                    <div title="FirstCry iOS App Download">
                                        <span className="parentSprite iosTag "></span>
                                        <span className="getAppText">Get for iOS</span>
                                    </div>
                                </div>
                                <div data-id="android" className="getAndroid left askB_1 button-lft-mrg" id="rdoandroid" onClick={this.submitdata(this.id)}>
                                    <p title="FirstCry Android App Download">
                                        <span className="parentSprite androidTag"></span>
                                        <span className="getAppText">Get for Android</span>
                                    </p>
                                </div>
                            </div>
                            <div className="parentSprite parentingImg"></div>
                        </div>
                    </div>
                </div>
            </aside>
        )
    }
}

export default Right;



// WEBPACK FOOTER //
// src/shared/right/Right.js